// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select_mainSelect__NJZxL {
  width: fit-content;
  min-width: 100px;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/CustomSelect/select.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AACF","sourcesContent":[".mainSelect {\n  width: fit-content;\n  min-width: 100px;\n  height: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainSelect": `select_mainSelect__NJZxL`
};
export default ___CSS_LOADER_EXPORT___;
